import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function CTPublication() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>CTPublication Dataset</BlockTitle>
          <BlockSubtitle>Color Transfer Publication Dataset</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText>The evaluation of color transfer algorithms presents challenges due to the diverse image sets used across different publications to demonstrate their efficacy. The inherently subjective nature of color transfer evaluation compounds this issue, as there isn't a universally accepted objective metric that flawlessly gauges result quality. To standardize evaluations and enable more accurate comparisons between algorithms, it's crucial to assess each algorithm using a consistent set of images. This dataset addresses this need by providing source, reference, and output images from a range of publications.</BlockText>
        </BlockContent>
      </Block>



      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
            <ul>
                <li>Includes Source, Reference, and Output images curated from past color and style transfer studies.</li>
                <li>Facilitates streamlined comparison and validation of outcomes from various publications.</li>
                <li>Features images from 13 distinct studies (refer to the README within the dataset for specific publications).</li>
                <li>Images have been post-processed to eliminate any labels.</li>
                {/* <li>Only images with the appropriate license are available.</li> */}
            </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/example_ctpublication.webp'}/>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="1200px">
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton onClick={() => window.open('https://huggingface.co/datasets/hpotechius/CTPublicationDataset')}>Download</BlockButton>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default CTPublication;